export default {
  'fdicLogo.wordmark': 'FDIC-Insured - Backed by the full faith and credit of the U.S. Government',
  'fdicLogo.logoAlt': 'FDIC'
};
